import React from 'react';

import './loader.scss';

const Loader = ({ size }) => (
    <div className="loader" style={size ? { width: `${size}px`, height: `${size}px` } : {}} />
);

export default Loader;